import api from 'common/api'
import { actions as snactions } from 'store/snackbar'

import { Message } from '../types'

export const onDeleteMessage = ({
  message,
  onChange,
  onCloseDeleteModal,
  dispatch,
}: {
  message: Message
  onChange: () => void
  onCloseDeleteModal: () => void
  dispatch: any
}) => {
  return api
    .delete(`/api/college/${message.Scid}/message/${message.Id}`)
    .then(() => {
      onChange()
    })
    .catch(() => dispatch(snactions.addSnackbarItem('An error occurred while deleting this message.')))
    .finally(onCloseDeleteModal)
}

export const onEnableMessage = ({
  message,
  enabled,
  onChange,
  dispatch,
}: {
  message: Message
  enabled: boolean
  onChange: () => void
  dispatch: any
}) => {
  return api
    .patch(`/api/college/${message.Scid}/message/${message.Id}`, message, { ...message, Disabled: !enabled })
    .then(() => onChange())
    .catch(() => dispatch(snactions.addSnackbarItem('An error occurred while updating this message.')))
}
